import style from '@/style/settings.scss';

class Spread {
    constructor (cards, layout, __actions, onResize) {
    
        this.cards = cards;
        this.layout = layout;
        this.__actions = __actions
        this.onResize = onResize;
        this.nbrOfActions;
        this.actionCounter;
        this.reset();

    }

    get hasBegin () {

        return this.deck.length < this.cards.length;

    }

    get done () {

        return this.actions.length > 0 ? false : true;

    }

    getCard (slug) {

        return this.cards.find(card => card.slug == slug);

    }

    getCardSlotPos (slug) {

        let cardSlot = this.layout[slug];
        let x = (cardSlot.gridX * this.cardWidth) + (cardSlot.gridX * this.cardHMargin);
        let y = (cardSlot.gridY * this.cardHeight) + (cardSlot.gridY * this.cardVMargin);

        return {slug, ...cardSlot, x, y};

    }

    getCardSlotsPos () {

        let cardSlotsPos = {};
        Object.keys(this.layout).forEach(slug => {
            cardSlotsPos[slug] = this.getCardSlotPos(slug);
        });

        return cardSlotsPos;

    }

    next () {

        if (this.done) return false;

        let card = this.pullRandomCard();
        let action = this.shiftAction();
        let cardSlotPos = this.getCardSlotPos(action.target);

        action.setCards(card, this.result);

        return {
            slug: card.slug,
            name: card.name,
            slot: cardSlotPos,
            result: this.result
        };

    }

    pullRandomCard () {

        let randomIndex = Math.floor(Math.random()*this.deck.length);
        let card = this.deck.splice(randomIndex, 1)[0];

        return card;

    }

    reset () {

        this.deck = Array.from(this.cards);
        this.actions = this.__actions();
        this.nbrOfActions = this.actions.length;
        this.actionCounter = 0;
        this.result = Object.keys(this.layout).reduce((acc, slug) => {
            acc[slug] = null;
            return acc;
        }, {});

    }

    setLayoutDimension () {
        let Lbreakpoint = parseFloat(style.cardLBreakpoint);
        let XSbreakpoint = parseFloat(style.cardXsBreakpoint);
        let Sbreakpoint = parseFloat(style.cardSBreakpoint);

        if (window.innerWidth > Lbreakpoint) {
            this.cardWidth = parseFloat(style.cardLWidth);
            this.cardHeight = parseFloat(style.cardLHeight);
            this.cardHMargin = parseFloat(style.cardLHMargin);
            this.cardVMargin = parseFloat(style.cardLVMargin);        
        }
        else if (window.innerWidth < XSbreakpoint) {
            this.cardWidth = parseFloat(style.cardXsWidth);
            this.cardHeight = parseFloat(style.cardXsHeight);
            this.cardHMargin = parseFloat(style.cardXsHMargin);
            this.cardVMargin = parseFloat(style.cardXsVMargin);
        }
        else if (window.innerWidth < Sbreakpoint) {
            this.cardWidth = parseFloat(style.cardSWidth);
            this.cardHeight = parseFloat(style.cardSHeight);
            this.cardHMargin = parseFloat(style.cardSHMargin);
            this.cardVMargin = parseFloat(style.cardSVMargin);
        }
        else {
            this.cardWidth = parseFloat(style.cardWidth);
            this.cardHeight = parseFloat(style.cardHeight);
            this.cardHMargin = parseFloat(style.cardHMargin);
            this.cardVMargin = parseFloat(style.cardVMargin);
        }

        this.onResize({
            cardWidth: this.cardWidth, cardHeight: this.cardHeight,
            cardHMargin: this.cardHMargin, cardVMargin: this.cardVMargin,
            slotsPos: this.getCardSlotsPos()
        });

    }

    shiftAction () {

        if (this.done) return;
        this.actionCounter ++;
        return this.actions.shift();

    }
}

export default Spread;
